import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import TopNavItem from "./TopNavItem"

const MobileNavTitle = styled.a``

const MobileNavToggle = styled.i``

function TopNav({ navItems, onToggleMobileNav, theme }) {
  const navLinkClassNames = "nav-link nav-toggler waves-effect waves-dark d-print-none"

  const navLinks = navItems.map(navItem => {
    return (
      <TopNavItem
        key={navItem.route}
        route={navItem.route}
        text={navItem.name}
        linkClassNames={navLinkClassNames}
        theme={theme}
      />
    )
  })

  return (
    <nav className="navbar top-navbar navbar-expand-lg navbar-light">
      <div className="navbar-collapse">
        <ul className="navbar-nav mr-auto mt-lg-0">
          <li className="nav-item">
            <a
              className="nav-link nav-toggler hidden-lg-up waves-effect waves-dark"
              onClick={onToggleMobileNav}
            >
              <MobileNavToggle className="mdi mdi-menu d-print-none" />
            </a>
          </li>
          <li className="nav-item hidden-lg-up">
            <MobileNavTitle className={navLinkClassNames} onClick={onToggleMobileNav}>
              Talent Toolbox Reports
            </MobileNavTitle>
          </li>
          {navLinks}
        </ul>
      </div>
    </nav>
  )
}

TopNav.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      route: PropTypes.string.isRequired
    })
  ).isRequired,
  onToggleMobileNav: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired
  }).isRequired
}

export default TopNav



// WEBPACK FOOTER //
// ./src/components/layout/navigation/TopNav.jsx